import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { ItemSerie } from './item-serie.model';
import { NTECH_API } from '../app.api';
import { ItemService } from '../item/item.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-item-serie',
  templateUrl: './item-serie.component.html',
  styleUrls: ['./item-serie.component.css']
})
export class ItemSerieComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  colunasGridItemSerie = [];
  itemSerie = null;
  listaItem = [];
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  editOptionsGridItemSerie = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true
  };

  listaSituacao = [
    {Id: 'A', Descricao: 'Ativo'},
    {Id: 'I', Descricao: 'Inativo'}
  ];

  constructor(
    @Inject(Http) http: Http,
    private itemService: ItemService
  ) {

    this.itemSerie = new CustomStore({
      insert: function (values) {
        // Adicionar data cadastro aqui
        console.log(values.DtCadastro);

        if ( (values.DtCadastro === undefined) || (values.DtCadastro === null)) {
          values.DtCadastro = new Date();
        }

        return http.post(`${NTECH_API}/item-serie/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/item-serie/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/item-serie/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/item-serie/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();

    this.itemService.getItems()
    .subscribe(items => {
      this.listaItem = items;

      this.colunasGridItemSerie = [
        {
          dataField: 'Id',
          dataType: 'dxTextBox',
          caption: 'ID',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'IdItem',
          caption: 'Item',
          lookup: {
              dataSource: this.listaItem,
              displayExpr: 'Descricao',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Item é obrigatória.'
          }],
          visible: true
        },
        {
          dataField: 'DtCadastro',
          dataType: 'date',
          caption: 'Data do Cadastro',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'NumeroSerie',
          dataType: 'string',
          caption: 'Número de Serial',
          validationRules: [{
            type: 'required',
            message: 'Número de Serial é obrigatório.'
          }]
        },
        {
          dataField: 'HFCMacAdress',
          dataType: 'string',
          caption: 'HFC Mac Adress',
          visible: false
        },
        {
          dataField: 'MTAMacAdress',
          dataType: 'string',
          caption: 'MTA Mac Adress',
          visible: false
        },
        {
          dataField: 'USBAdress',
          dataType: 'string',
          caption: 'USB Adress',
          visible: false
        },
        {
          dataField: 'IPAdress',
          dataType: 'string',
          caption: 'IP Adress',
          visible: false
        },
        {
          dataField: 'NotaFiscalCompra',
          dataType: 'string',
          caption: 'Nota Fiscal Compra',
          visible: false
        },
        {
          dataField: 'DocumentoSistema',
          dataType: 'string',
          caption: 'DocSis',
          visible: false
        }
      ];
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/item-serie/item-serie.component.ts